import { useState, useLayoutEffect } from "react";
import { getPanelElement } from "react-resizable-panels";

export function usePanelWidthWithMargin(id, containerId = "main") {
  const [width, setWidth] = useState(0);
  const [marginRight, setMarginRight] = useState(0);

  useLayoutEffect(() => {
    let observer;
    const updateDimensions = () => {
      const panelElement = getPanelElement(id);
      const containerElement = document.getElementById(containerId);

      if (panelElement && containerElement) {
        const panelRect = panelElement.getBoundingClientRect();
        const containerRect = containerElement.getBoundingClientRect();
        setWidth(panelElement.offsetWidth);
        setMarginRight(containerRect.right - panelRect.right); // Calculate margin to the right
      }

      // Observe panel size changes
      if (panelElement) {
        observer = new ResizeObserver(() => {
          if (panelElement && containerElement) {
            const panelRect = panelElement.getBoundingClientRect();
            const containerRect = containerElement.getBoundingClientRect();

            setWidth(panelElement.offsetWidth);
            setMarginRight(containerRect.right - panelRect.right);
          }
        });
        observer.observe(panelElement);
      }
    };

    updateDimensions();

    // Fallback for dynamically added elements
    const mutationObserver = new MutationObserver(updateDimensions);
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    return () => {
      if (observer) observer.disconnect();
      mutationObserver.disconnect();
    };
  }, [id, containerId]);

  return { width, marginRight };
}
